// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__29iXx","Logo":"Toolbar_Logo__2UU8e","DesktopOnly":"Toolbar_DesktopOnly__dIRAN"};